import { Link } from "react-router-dom";

export default function Pagination({ currentPage, totalPages, basePath = "/blog", category, search }) {
  const buildUrl = (page) => {
    const params = new URLSearchParams();
    if (page > 1) params.set("page", page);
    if (category && category !== "All Posts") params.set("category", category);
    if (search) params.set("search", search);
    const qs = params.toString();
    return qs ? `${basePath}?${qs}` : basePath;
  };

  const visible = [];
  const start = Math.max(1, currentPage - 2);
  const end = Math.min(totalPages, currentPage + 2);

  for (let i = start; i <= end; i++) {
    visible.push(i);
  }

  return (
    <nav className="flex items-center justify-center gap-2 mt-16" aria-label="Blog pagination">
      {currentPage > 1 && (
        <Link
          to={buildUrl(currentPage - 1)}
          className="glass rounded-xl px-4 py-2.5 text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 transition-all"
        >
          ← Prev
        </Link>
      )}

      {start > 1 && (
        <>
          <Link
            to={buildUrl(1)}
            className="glass rounded-xl w-10 h-10 flex items-center justify-center text-sm font-medium text-gray-400 hover:text-white hover:bg-white/10 transition-all"
          >
            1
          </Link>
          {start > 2 && (
            <span className="text-gray-500 text-sm px-1">...</span>
          )}
        </>
      )}

      {visible.map((page) =>
        page === currentPage ? (
          <span
            key={page}
            className="rounded-xl w-10 h-10 flex items-center justify-center text-sm font-bold bg-cyber-blue text-black"
          >
            {page}
          </span>
        ) : (
          <Link
            key={page}
            to={buildUrl(page)}
            className="glass rounded-xl w-10 h-10 flex items-center justify-center text-sm font-medium text-gray-400 hover:text-white hover:bg-white/10 transition-all"
          >
            {page}
          </Link>
        )
      )}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && (
            <span className="text-gray-500 text-sm px-1">...</span>
          )}
          <Link
            to={buildUrl(totalPages)}
            className="glass rounded-xl w-10 h-10 flex items-center justify-center text-sm font-medium text-gray-400 hover:text-white hover:bg-white/10 transition-all"
          >
            {totalPages}
          </Link>
        </>
      )}

      {currentPage < totalPages && (
        <Link
          to={buildUrl(currentPage + 1)}
          className="glass rounded-xl px-4 py-2.5 text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 transition-all"
        >
          Next →
        </Link>
      )}
    </nav>
  );
}
